import React from "react";
import AOS from "aos";
AOS.init();

const hero = () => {
	return (
		<div className="container">
			<div className="row">
				<div className="col-md-12 text-center">
					<h2>My Resume</h2>
					<div className="space-border"></div>
				</div>
			</div>
			<div className="row gh-5">
				<div className="col-lg-6" data-aos="fade-up" data-aos-once="true">
					<div className="p-4">
						<h3 className="s_border">Experiences</h3>
						<ul className="d_timeline">
							<li className="d_timeline-item">
								<h3 className="d_timeline-title">2023 - now</h3>
								<p className="d_timeline-text">
									<span className="d_title">Crunch Craft</span>
									<span className="d_company">Front End Developer</span>
									Vue Js Developer
								</p>
							</li>
							<li className="d_timeline-item">
								<h3 className="d_timeline-title">2022</h3>
								<p className="d_timeline-text">
									<span className="d_title">Web Designer</span>
									<span className="d_company">Elinks</span>
									Nextjs Reactjs
								</p>
							</li>
							<li className="d_timeline-item">
								<h3 className="d_timeline-title">2021-2022</h3>
								<p className="d_timeline-text">
									<span className="d_title">Wordpress and Php Developer</span>
									<span className="d_company">Digital Konnecter System</span>
									Html Css Jquery
								</p>
							</li>
						</ul>
					</div>
				</div>

				<div className="col-lg-6" data-aos="fade-up" data-aos-once="true">
					<div className="p-4">
						<h3 className="s_border">Education & Courses</h3>
						<ul className="d_timeline">
							<li className="d_timeline-item">
								<h3 className="d_timeline-title">2022</h3>
								<p className="d_timeline-text">
									<span className="d_title">MERN Course by Brad Traversy</span>
									<span className="d_company">Udemy</span>
									Learnt about React and Firebase
								</p>
							</li>
							<li className="d_timeline-item">
								<h3 className="d_timeline-title">2022</h3>
								<p className="d_timeline-text">
									<span className="d_title">Meta Front End Developer</span>
									<span className="d_company">Meta</span>Front end complete
									development course
								</p>
							</li>
							<li className="d_timeline-item">
								<h3 className="d_timeline-title">2018 - 2022</h3>
								<p className="d_timeline-text">
									<span className="d_title">
										Bachelors in Computer Sciences
									</span>
									<span className="d_company">Lahore Garrison University</span>
									Completed my Bachelors in Computer Sciences with 3.0 gpa
								</p>
							</li>
						</ul>
					</div>
				</div>
				<div className="spacer-double"></div>
			</div>
		</div>
	);
};

export default hero;
